import React from 'react'
import { useEffect } from "react"
import LADDA from "../../assets/portfolio.png"
import DRYVA from "../../assets/dryva.png"
import Discover from "../../assets/discover.png"
import Stories from "../../assets/stories.png"
import WOW from "wowjs"
import "./Work.css"

const Work = () => {
  useEffect(() => {
    new WOW.WOW({
      live: false
    }).init();
  }, [])
  return (
    <>
      <div id='work' className='py-5 md:block hidden'>
        <div className="text-center py-5 md:text-left ">
          <h3 className='font-bold md:text-3xl text-2xl'>Some Projects Worked On...</h3>
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 py-4 lg:py-0 wow">
          <div className='container'>
            <img className='work-image' src={LADDA} alt="" />

            <div className="middle">
              <a href="https://play.google.com/store/apps/details?id=com.ladda.production&ah=oHQER924wUTTejhG1L0avAUtZlk"
                className="text-btn"
                target="_blank">
                Discover the project
              </a>
            </div>
          </div>
          <div className='text-container p-[2rem] items-center xl:space-y-[5rem]'>
            <div className='project-year'>
              <h3>2021</h3>
            </div>
            <div className='project-title'>
              <h1>LADDA</h1>
            </div>
            <div className='project-info'>
              <p>
                Ladda is a one stop investment platform that gives you
                access to an array of products. Savings, Mutual funds and Stocks.
                You can invest in Naira and dollar denominated assets all on one platform.
              </p>
            </div>
            <div className='discover-project'>
              <a href="https://play.google.com/store/apps/details?id=com.ladda.production&ah=oHQER924wUTTejhG1L0avAUtZlk" target="_blank">
                Discover the project
              </a>
            </div>
          </div>
        </div>



        <div className="grid md:grid-cols-2 grid-cols-1 py-2 lg:py-0">
          <div className='text-container p-[2rem] items-center xl:space-y-[5rem]'>
            <div className='project-year'>
              <h3>2020</h3>
            </div>
            <div className='project-title'>
              <h1>DRYVA (For Drivers)</h1>
            </div>
            <div className='project-info'>
              <p>
                Joining Dryva as a driver connects you to a rider within a few hours after you have been verified and you can start receiving your payments seamlessly.
              </p>
            </div>
            <div className='discover-project'>
              <a href="https://play.google.com/store/apps/details?id=com.dryva.driver&hl=en" target="_blank">
                Discover the project
              </a>
            </div>
          </div>

          <div className='container'>
            <img className='work-image' src={DRYVA} alt="" />

            <div className="middle">
              <a href="https://play.google.com/store/apps/details?id=com.dryva.driver&hl=en"
                className="text-btn"
                target="_blank">
                Discover the project
              </a>
            </div>
          </div>
        </div>





        <div className="grid md:grid-cols-2 grid-cols-1 py-2 lg:py-0">
          <div className='container'>
            <img className='work-image' src={Discover} alt="" />

            <div className="middle">
              <a href="https://play.google.com/store/apps/details?id=com.spottr.android.app"
                className="text-btn"
                target="_blank">
                Discover the project
              </a>
            </div>
          </div>
          <div className='text-container p-[2rem] items-center xl:space-y-[5rem]'>
            <div className='project-year'>
              <h3>2020</h3>
            </div>
            <div className='project-title'>
              <h1>SPOTTR</h1>
            </div>
            <div className='project-info'>
              <p>
                Find anything you want, from anywhere in the world, using our interactive map and smart search feature.
              </p>
            </div>
            <div className='discover-project'>
              <a href="https://play.google.com/store/apps/details?id=com.spottr.android.app" target="_blank">
                Discover the project
              </a>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 grid-cols-1 py-2 lg:py-0">

          <div className='text-container p-[2rem] items-center xl:space-y-[5rem]'>
            <div className='project-year'>
              <h3>2019</h3>
            </div>
            <div className='project-title'>
              <h1>KID STORIES</h1>
            </div>
            <div className='project-info'>
              <p>
                This application provides users of all ages with bedtime stories that can be read in app and also gives them the opportunity to write their own stories and upload it for other users to view and enjoy.
              </p>
            </div>
            <div className='discover-project'>
              <a href="https://play.google.com/store/apps/details?id=com.project.android_kidstories" target="_blank">
                Discover the project
              </a>
            </div>
          </div>

          <div className='container'>
            <img className='work-image' src={Stories} alt="" />

            <div className="middle">
              <a href="https://play.google.com/store/apps/details?id=com.project.android_kidstories"
                className="text-btn"
                target="_blank">
                Discover the project
              </a>
            </div>
          </div>
        </div>
      </div>

 {/* SMALL SCREEN UI */}


      <div id='works' className='mt-[1.5rem]'>

      <div className='md:hidden p-2 grid md:grid-cols-2 grid-cols-1 space-y-4'>
        
      <div className="text-center py-5 md:text-left ">
          <h3 className='font-bold md:text-3xl text-2xl'>Some Projects Worked On...</h3>
        </div>
        
        <div>
        <div
          href=""
          class="block overflow-hidden border border-slate-700 rounded-lg shadow-lg"
        >
          <img
            alt="Office"
            src={LADDA}          
            class="object-cover w-full h-56"
          />
          <div className="p-6">
            <h3 className='text-xl font-700'>2021</h3>
            <h3 className="text-2xl font-bold"> LADDA </h3>
            <p className="mt-2 text-sm text-gray-500">
            Ladda is a one stop investment platform that gives you
                access to an array of products. Savings, Mutual funds and Stocks.
                You can invest in Naira and dollar denominated assets all on one platform.
               </p>
            <a
            href="https://play.google.com/store/apps/details?id=com.ladda.production&ah=oHQER924wUTTejhG1L0avAUtZlk" target="_blank"
              className="inline-block pb-1 mt-4 font-medium text-white border-b border-white "
            >
              Discover Project
              <a href="https://play.google.com/store/apps/details?id=com.ladda.production&ah=oHQER924wUTTejhG1L0avAUtZlk" target="_blank" aria-hidden="true">&rarr;</a>
            </a>
          </div>
        </div>
        </div>

        <div>
        <div
          href=""
          class="block overflow-hidden border border-slate-700 rounded-lg shadow-sm"
        >
          
          <img
            alt="Office"
            src={DRYVA}          
            class="object-cover w-full h-56"
          />
          <div className="p-6">
            <h3 className='text-xl font-700'>2020</h3>
            <h3 className="text-2xl font-bold"> DRYVA (For Drivers) </h3>
            <p className="mt-2 text-sm text-gray-500">
            Joining Dryva as a driver connects you to a rider within a few hours after you have been verified and you can start receiving your payments seamlessly. </p>
            <a
            href="https://play.google.com/store/apps/details?id=com.dryva.driver&hl=en" target="_blank"
              className="inline-block pb-1 mt-4 font-medium text-white border-b border-white "
            >
              Discover Project
              <a href="https://play.google.com/store/apps/details?id=com.dryva.driver&hl=en" target="_blank" aria-hidden="true">&rarr;</a>
            </a>
          </div>
        </div>
        </div>

        <div>
        <div
          href=""
          class="block overflow-hidden border border-slate-700 rounded-lg shadow-sm"
        >
          
          <img
            alt="Office"
            src={Discover}          
            class="object-cover w-full h-56"
          />
          <div className="p-6">
            <h3 className='text-xl font-700'>2020</h3>
            <h3 className="text-2xl font-bold"> SPOTTR</h3>
            <p className="mt-2 text-sm text-gray-500">
            Find anything you want, from anywhere in the world, using our interactive map and smart search feature.</p>
            <a
            href="https://play.google.com/store/apps/details?id=com.spottr.android.app" target="_blank"
              className="inline-block pb-1 mt-4 font-medium text-white border-b border-white "
            >
              Discover Project
              <a href="https://play.google.com/store/apps/details?id=com.spottr.android.app" target="_blank" aria-hidden="true">&rarr;</a>
            </a>
          </div>
        </div>
        </div>


        <div>
        <div
          href=""
          class="block overflow-hidden border border-slate-700 rounded-lg shadow-lg"
        >
          
          <img
            alt="Office"
            src={Stories}          
            class="object-cover w-full h-56"
          />
          <div className="p-6">
            <h3 className='text-xl font-700'>2019</h3>
            <h3 className="text-2xl font-bold">KID STORIES</h3>
            <p className="mt-2 text-sm text-gray-500">
            This application provides users of all ages with bedtime stories that can be read in app and also gives them the opportunity to write their own stories and upload it for other users to view and enjoy.
            </p>
            <a
            href="https://play.google.com/store/apps/details?id=com.project.android_kidstories" target="_blank"
              className="inline-block pb-1 mt-4 font-medium text-white border-b border-white"
            >
              Discover Project
              <a href="https://play.google.com/store/apps/details?id=com.project.android_kidstories" target="_blank" aria-hidden="true">&rarr;</a>
            </a>
          </div>
        </div>
        </div>

       
      </div>
      </div>

      
    </>
  )
}

// LINKS

// https://play.google.com/store/apps/details?id=com.dryva.driver&hl=en
// https://play.google.com/store/apps/details?id=ng.jiggle.user&hl=en
// https://play.google.com/store/apps/details?id=com.project.android_kidstories
// https://play.google.com/store/apps/details?id=com.spottr.android.app
// https://play.google.com/store/apps/details?id=com.ladda.production&ah=oHQER924wUTTejhG1L0avAUtZlk
// https://play.google.com/store/apps/details?id=com.mobymagic.clairediary&hl=en&gl=US


export default Work
